import axios from "axios";

export default {
  async createAccount(username, displayname) {
    const response = await axios.post("/api/users", { username, displayname });
    return response.data;
  },

  async logout() {
    await axios.get("/auth/logout");
  },

  async checkUsername(username) {
    const response = await axios.get(`/api/usernames/${username}`);
    return response.data;
  },

  async createDeck(payload) {
    const response = await axios.post("/api/decks", payload);
    return response.data;
  },

  async publishVersion(id, payload) {
    payload.publish = true;
    const response = await axios.put(`/api/decks/${id}`, payload);
    return response.data;
  },

  async getUserDecks(username, params) {
    const response = await axios.get(`/api/users/${username}/decks`, {
      params,
    });
    return response.data;
  },

  async createNewVersion(id, payload) {
    const response = await axios.post(`/api/decks/${id}`, payload);
    return response.data;
  },
  async updateVersion(id, payload) {
    const response = await axios.put(`/api/decks/${id}`, payload);
    return response.data;
  },
  async updateTags(id, tags) {
    const response = await axios.put(`/api/decks/${id}/tags`, { tags });
    return response.data;
  },
  async getTags() {
    const response = await axios.get("/api/tags");
    return response.data;
  },
  async getDeck(id) {
    const deck = await axios.get(`/api/decks/${id}`);
    return deck.data;
  },
  async getDecks(params) {
    const deckList = await axios.get("/api/decks", { params });
    return deckList.data;
  },
  async getTrackableDecks(params) {
    const deckList = await axios.get("/api/trackable_decks", { params });
    return deckList.data;
  },
  // async getDataUri(params) {
  //   const response = await axios.get("/api/img", { params });
  //   return response.data.dataUri;
  // },
  async getDBDecks(params) {
    const deckList = await axios.get("/api/db/decks", { params });
    return deckList.data;
  },
  async getDBCards(params) {
    const cardList = await axios.get("/api/db/cards", { params });
    return cardList.data;
  },
  async getDBDeck(slug, params) {
    const deck = await axios.get(`/api/db/decks/${slug}`, { params });
    return deck.data;
  },
  async getDBCard(slug, params) {
    const card = await axios.get(`/api/db/cards/${slug}`, { params });
    return card.data;
  },
  async getDBSets(params) {
    const setList = await axios.get("/api/db/sets", { params });
    return setList.data;
  },
  async getDBBoards(params) {
    const boardList = await axios.get("/api/db/boards", { params });
    return boardList.data;
  },
  async likeDeck(id, liked = true) {
    const likeDeck = await axios.post(`/api/decks/${id}/like`, { liked });
    return likeDeck.data;
  },
  async getPosts(params) {
    const response = await axios.get(`/api/posts`, {
      params,
    });
    return response.data;
  },
  async getSectionPosts(section, params) {
    const response = await axios.get(`/api/posts/${section}`, {
      params,
    });
    return response.data;
  },
  async getPost(slug, params) {
    const response = await axios.get(`/api/post/${slug}`, {
      params,
    });
    return response.data;
  },
  async trackGame(game) {
    const response = await axios.post("/api/games", game);
    return response.data;
  },
  async updateGame(gameId, gameData) {
    const response = await axios.put(`/api/games/${gameId}`, gameData);
    return response.data;
  },
  async deleteGame(gameId) {
    const response = await axios.delete(`/api/games/${gameId}`);
    return response.data;
  },
  async getResultsGrid() {
    const response = await axios.get("/api/games/grid");
    return response.data;
  },
  async getUserResultsGrid(username) {
    const response = await axios.get(`/api/users/${username}/grid`);
    return response.data;
  },
  async getUserGames(username, params) {
    const response = await axios.get(`/api/users/${username}/games`, {
      params,
    });
    return response.data;
  },
  async getDeckGames(id, params) {
    const response = await axios.get(`/api/decks/${id}/games`, {
      params,
    });
    return response.data;
  },
  async getDeckGamesSummary(id) {
    const response = await axios.get(`/api/decks/${id}/games/summary`);
    return response.data;
  },
  async commentOnDeck(id, body, parent_id = null) {
    const comment = await axios.post(`/api/decks/${id}/comments`, {
      body,
      parent_id,
    });
    return comment.data;
  },
  async getDeckComments(id, params) {
    const response = await axios.get(`/api/decks/${id}/comments`, {
      params,
    });
    return response.data;
  },
  async getNotificationSummary() {
    const response = await axios.get("/api/notifications/summary");
    return response.data;
  },
};
